<template>
  <div>
    <Score :notes="voices" />
    <Score :notes="voices2" />
    <Score notes="(C4 E4 G4 Bb4)/q, (C4 Eb4 F4 A4)/q, (D4 F4 G4 B4)/h" />
    <Score notes="C4/8, D4, E4, F#4, G4, A4, B4, C5" />
  </div>
</template>

<script>
import Score from "@/components/Score";

export default {
  name: "DemoScores",
  components: { Score },
  data() {
    return {
      voices: "C4/q, E4, G4, B4",
      voices2: [
        { notes: "C4/8, D4, E4, F4, G4, A4, Bb4, C5" },
        { notes: "(C3 E3 G3)/w", stem: "down" }
      ]
    };
  }
};
</script>

<style></style>
